module.exports = __webpack_public_path__ + "static/media/fire1.dfa5bc6a.jpeg";